import { createSelector } from 'reselect';
import { getRefundPassengerLabel } from '../../lib/refundPassengerUtils';
import { getSelectedRefundFamilies } from '../passengers/selectors';
import { getSelectedReasonDocument } from '../selectedReason/selectors';
export const getDocumentsState = (state) => state.refund.documents;
export const getIsAllDocumentSelected = createSelector(getDocumentsState, documentsState => Object.values(documentsState).every(files => { var _a; return !!((_a = files === null || files === void 0 ? void 0 : files.filter(file => { var _a; return !((_a = file.error) === null || _a === void 0 ? void 0 : _a.length); })) === null || _a === void 0 ? void 0 : _a.length); }));
export const getPassengersDocuments = createSelector(getDocumentsState, getSelectedRefundFamilies, getSelectedReasonDocument, (documentsState, selectedPassengers, selectedReasonDocument) => {
    const documents = [];
    if (selectedReasonDocument) {
        selectedPassengers.forEach(passenger => {
            documents.push({
                passengerId: passenger.id,
                passengerFullName: getRefundPassengerLabel(passenger),
                documentType: selectedReasonDocument,
                files: documentsState[passenger.id]
            });
        });
    }
    return documents;
});
